import { z } from 'zod';
export const insuranceClaimsDocumentsCompletionCapability = 'documents.insurance-claim-completion.v1';
export const insuranceClaimsDocumentsCompletionSlot = 'insurance-claims.document-completion';
export const insuranceClaimsDocumentsCompletionProviderId = 'documents.server.insurance-claims-completion';
const idSchema = z.string().uuid();
const countSchema = z.number().int().nonnegative();
export const insuranceClaimsDocumentsCompletionProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(insuranceClaimsDocumentsCompletionCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const insuranceClaimsDocumentsCompletionProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(insuranceClaimsDocumentsCompletionCapability),
    projectId: idSchema,
    sourceLinkedCount: countSchema,
    signedCount: countSchema,
    finalizedArtifactCount: countSchema,
    signedAndFinalizedCount: countSchema,
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    observedAt: z.string().datetime({ offset: true }).nullable(),
}).superRefine((value, context) => {
    if (value.signedCount > value.sourceLinkedCount ||
        value.finalizedArtifactCount > value.sourceLinkedCount ||
        value.signedAndFinalizedCount > Math.min(value.signedCount, value.finalizedArtifactCount)) {
        context.addIssue({ code: 'custom', message: 'Document completion counts do not reconcile.' });
    }
});
export const insuranceClaimsDocumentsCompletionUnavailableReasonSchema = z.enum([
    'not-installed',
    'not-enabled',
    'permission-denied',
    'provider-invalid',
    'provider-failed',
]);
export const insuranceClaimsDocumentsCompletionAvailabilitySchema = z.discriminatedUnion('state', [
    insuranceClaimsDocumentsCompletionProviderResponseSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(insuranceClaimsDocumentsCompletionCapability),
        reasonCode: insuranceClaimsDocumentsCompletionUnavailableReasonSchema,
    }),
]);
//# sourceMappingURL=insurance-claims-documents-completion.contract.js.map